const bg = {
  login: {
    usernamePlaceholder: 'Потребителско име или имейл',
    usernamePlaceholderArch: 'Имейл',
    fullName: 'Три имена',
    password: 'Парола',
    confirmPassword: 'Потвърдете паролата',
    passwordMismatch: 'Паролата и потвърдената парола трябва да са едни и същи',
    invalidEmail: 'Невалиден имейл',
    acceptPolicyPrefix: 'Съгласен съм с',
    policyLinkText: 'политиката за защита на личните данни',
    signIn: 'Вход',
    register: 'Регистрация',
    registrationSuccessTitle: 'Регистрацията беше успешна.',
    registrationSuccessBody: 'Акаунтът Ви ще бъде прегледан и активиран от администраторите на сайта.',
    switchToRegister: 'Регистрация',
    switchToLogin: 'Вход'
  }
}

export default bg
